import Component from "@tunnel-components/@sharded/error/component";
import * as React from "react";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onRelead
 * @name
 * @name render
 * @infos "https://cyclope.ai"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     */
    this.state = {};
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onRelead = this.onRelead.bind(this);
  }
  /**
   * Ouverture / Fermeture
   * @method onRelead
   * @param {number}    event
   * @infos "https://reactjs.org"
   */
  public onRelead = (event: any): void => window.location.reload(true);

  /**
   * Cycle de vie React : componentWillUnmount
   * @public
   * @method componentWillUnmount
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** clear Interval */
    }
    clearInterval(this.state.countInterval);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ countInterval: null }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM clearInterval(this.state.countInterval);
   * @param { void }
   * @infos "https://reactjs.org"
   */
  // public componentDidMount (){

  // { /** Empêcher la mutation du state */}
  // this.setState((state: any):any => ({ countInterval : setTimeout(() =>  window.location.reload(true), 10000)}))
  // }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return <Component onRelead={this.onRelead} />;
  }
}
{
  /** exporter le Container */
}
export default Container;



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/error/container.tsx